import { render, staticRenderFns } from "./EmployerDependentDetail.vue?vue&type=template&id=fbe9f730&"
import script from "./EmployerDependentDetail.vue?vue&type=script&lang=js&"
export * from "./EmployerDependentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports